var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col gap-4", class: _vm.errorShow ? "error" : "" },
    [
      _c(
        "div",
        { staticClass: "flex gap-16" },
        _vm._l(_vm.options, function (option) {
          return _c(
            "label",
            {
              key: option.id,
              staticClass:
                "input-radio-wrapp relative flex items-center gap-[10px] text-sm text-blue cursor-pointer",
            },
            [
              _c("input", {
                staticClass: "absolute opacity-0 peer",
                attrs: { type: "radio", name: _vm.name },
                domProps: { checked: option.id === _vm.value },
                on: {
                  change: function ($event) {
                    return _vm.$emit("input", option.id)
                  },
                },
              }),
              _vm._v(" "),
              _c("span", {
                staticClass:
                  "input-radio-dot flex items-center justify-center w-5 h-5 rounded-full border border-blue duration-100 before:block before:w-3 before:h-3 before:rounded-full before:bg-blue before:opacity-0 before:scale-50 before:duration-200",
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(option.text))]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.errorShow
        ? _c("p", { staticClass: "text-xs text-red" }, [
            _vm._v(_vm._s(_vm.errorText)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }